const X = 0;
const Y = 1;
const WIDTH = 2;
const HEIGHT = 3;

export {
  X, Y, WIDTH, HEIGHT,
};
